import React from 'react';
import { Phone, Mail, MapPin, MessageSquare, Clock, Globe } from 'lucide-react';
import { Button } from "../components/ui/button";
import { Link } from 'react-router-dom';

export const Contact = () => {
  const contactMethods = [
    {
      icon: <Phone className="w-5 h-5" />,
      title: "Whatsapp Support",
      value: "+63975296193",
      description: "Mon-Fri from 8am to 5pm",
      action: "Whatsapp Us",
      link: "https://wa.me/+63975296193?text=Hello Hays Prime Bank"
    },
    {
      icon: <Mail className="w-5 h-5" />,
      title: "Email Us",
      value: "support@haysprime.com",
      description: "Online 24/7 support",
      action: "Send Email",
      link: "mailto:support@haysprime.com"
    },
    {
      icon: <MapPin className="w-5 h-5" />,
      title: "Visit Office",
      value: "Grindelwald, Switzerland",
      description: "Melanie Werlen-Steiner",
      action: "Get Directions",
      link: "https://maps.google.com"
    }
  ];

  return (
    <div className="min-h-screen bg-slate-50 px-3">
      <div className="max-w-4xl mx-auto space-y-8">
        
        {/* Header Section */}
        <div className="text-center space-y-3 pt-10">
          <h1 className="text-xl font-black tracking-tight text-slate-900">Get in touch</h1>
          <p className="text-slate-500 font-medium text-sm">We're here to help with your HaysPrime experience.</p>
        </div>

        {/* Main Contact Card */}
        <section className="relative overflow-hidden bg-slate-900 rounded-[3rem] p-8 md:p-12 text-white shadow-2xl">
          <div className="absolute top-0 right-0 w-96 h-96 bg-blue-500/10 blur-3xl rounded-full -mr-32 -mt-32" />
          
          <div className="relative grid md:grid-cols-2 gap-12 items-center">
            <div className="space-y-6">
              <div className="inline-flex items-center gap-2 bg-white/10 px-4 py-2 rounded-full border border-white/10">
                <Globe size={16} className="text-blue-400" />
                <span className="text-sm font-black uppercase tracking-widest">Global Support</span>
              </div>
              <h2 className="text-xl font-black leading-tight">Expert support for your financial growth.</h2>
              <p className="text-slate-400 leading-relaxed text-sm">
                Whether you have a question about transactions, security, or account verification, our team is ready to assist you.
              </p>
              
              <div className="flex flex-wrap gap-4">
                <div className="flex items-center gap-3 bg-white/5 p-4 rounded-2xl border border-white/5">
                   <Clock className="text-blue-400" size={20} />
                   <div>
                     <p className="text-[12px] uppercase font-black tracking-wider text-slate-500">Response Time</p>
                     <p className="text-sm font-bold">&lt; 24 Hours</p>
                   </div>
                </div>
              </div>
            </div>

            <div className="bg-white/10 backdrop-blur-md rounded-[2.5rem] p-8 border border-white/10 space-y-6">
              <h3 className="text-sm font-black">Live Chat</h3>
              <p className="text-slate-300 text-sm">Need an instant answer? Start a conversation with our live agent on Whatsapp</p>
              <Link
                to={'https://wa.me/+639752961393&text=Hello Hays Prime Bank'} >
            <Button
                className="w-full bg-white text-slate-900 hover:bg-slate-100 rounded-2xl h-10 mt-3 font-black text-sm shadow-xl"
              >
                <MessageSquare className="mr-2" /> Start Chat
              </Button>
              </Link>
            </div>
          </div>
        </section>

        {/* Contact Methods Grid */}
        <div className="grid md:grid-cols-3 gap-6">
          {contactMethods.map((method, idx) => (
            <div key={idx} className="bg-white p-8 rounded-[2.5rem] border border-slate-100 shadow-sm hover:shadow-md transition-all group">
              <div className="w-12 h-12 bg-slate-50 rounded-2xl flex items-center justify-center text-slate-900 group-hover:bg-slate-900 group-hover:text-white transition-colors duration-500">
                {method.icon}
              </div>
              <h4 className="mt-6 font-black text-slate-900 uppercase text-sm tracking-widest">{method.title}</h4>
              <p className="mt-2 font-bold text-lg text-slate-900 tracking-tight">{method.value}</p>
              <p className="mt-1 text-sm text-slate-500 font-medium">{method.description}</p>
              <a 
                href={method.link} 
                className="mt-6 inline-flex items-center text-sm font-black text-blue-600 hover:text-blue-700 underline underline-offset-4"
              >
                {method.action}
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
